export const getSettingsPath = (path: string, isJCS: boolean) =>
	isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
